import {concat} from 'lodash';
import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {CancelToken} from '../../../../helpers/asyncCancelHelpers';
import {buildTagSearchUrl} from '../../../../helpers/models/tagHelpers';
import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {ApiSearchTags, SearchTagModel} from '../../../../models/api/searchTagModel';
import {TagBehaviorsEnum} from '../../../../models/api/tagModel';
import {fetchApiAsync} from '../../../../services/http/http';
import {AppState} from '../../../../store/appState';
import {getCompany} from '../../../../store/data/company/companySelectors';
import {PickParentTagDropdown} from './pickParentTagDropdown';

/*
 * Props.
 */

interface PickParentTagDropdownContainerProps {
  namespace: string;
  excludeTagId?: number;
}

/*
 * Selectors.
 */

function getNamespace(_state: AppState, props: PickParentTagDropdownContainerProps) {
  return props.namespace;
}

function getExcludeTagId(_state: AppState, props: PickParentTagDropdownContainerProps) {
  return props.excludeTagId;
}

function makeGetFetchTagsAsync() {
  return createSelector(
    [getCompany, getNamespace, getExcludeTagId],
    (company, namespace, excludeTagId) =>
      async function fetchAsync(
        query: string,
        tags: ReadonlyArray<SearchTagModel | null>,
        cancelToken: CancelToken,
      ) {
        const url = buildTagSearchUrl(company, query, {
          namespaces: [namespace],
          offset: tags.length,
          excludeTagIds: excludeTagId ? [excludeTagId] : [],
          behaviors: [TagBehaviorsEnum.CAN_PARENT],
        });

        const newTags = await fetchApiAsync(ApiSearchTags, url, {cancelToken});
        return {
          items: concat(tags.length > 0 ? tags : [null], newTags.tags),
          canLoadMore: newTags.tags.length === newTags.limit,
        };
      },
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<PickParentTagDropdownContainerProps>()(() => ({
  company: getCompany,
  fetchTagsAsync: makeGetFetchTagsAsync(),
}));

export const PickParentTagDropdownContainer = connect(mapStateToProps)(PickParentTagDropdown);
